import { c as _c } from "react/compiler-runtime";
import { Title } from "@justhome/react-ui";
import { Maybe } from "@lib/generated/graphql";
import { FC } from "react";
const AccordionHeader: FC<{
  title?: Maybe<string>;
  subtitle?: Maybe<string>;
  inverted?: boolean;
  serifClass?: string;
}> = t0 => {
  const $ = _c(9);
  const {
    title,
    subtitle,
    inverted,
    serifClass
  } = t0;
  let t1;
  if ($[0] !== inverted || $[1] !== serifClass || $[2] !== title) {
    t1 = title && <Title inverted={inverted} serifClass={serifClass} className="text-d3">{title}</Title>;
    $[0] = inverted;
    $[1] = serifClass;
    $[2] = title;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== subtitle) {
    t2 = subtitle && <p className="text-body-1 mt-3s mb-m">{subtitle}</p>;
    $[4] = subtitle;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div>{t1}{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default AccordionHeader;